const menuWraps = [
  {
    id: 1,
    name: "Noor Works",
    description: [
      "Choice of Beef or Chicken Shawerma Hummus, Tahini or Garlic Sauce Lettuce, tomatoes, onions, pickles and french fries inside wrap.",
    ],

    price: "$13.50",
  },
  {
    id: 2,
    name: "Beef Kebab Wrap",
    description: ["Flame broiled marinated Angus beef."],
    price: "$13.50",
  },
  {
    id: 3,
    name: "Beef Shawerma Wrap",
    description: [
      "Tender marinated Angus beef, slow cooked on a vertical rotisserie.",
    ],
    price: "$12.46",
  },
  {
    id: 4,
    name: "Lule Kebab Wrap",
    description: ["Flame broiled marinated ground Angus beef."],
    price: "$12.46",
  },
  {
    id: 5,
    name: "Chicken Kebab Wrap",
    description: ["Flame broiled marinated chicken breast."],
    price: "$12.98",
  },
  {
    id: 6,
    name: "Chicken Shawerma Wrap",
    description: [
      "Tender marinated chicken, slow-cooked on a vertical rotisserie.",
    ],
    price: "$12.46",
  },
  {
    id: 7,
    name: "Falafel Wrap",
    description: ["Falafel balls, tahini sauce, lettuce, tomato, and pickles."],
    price: "$11.42",
  },
  {
    id: 8,
    name: "Veggie Lovers Wrap",
    description: [
      "Hummus or Baba Dip wrapped with lettuce, tomatoes, pickled cucumbers, pickled turnips & marinated onions.",
    ],
    price: "$10.90",
  },
];

export default menuWraps;
